import React from "react";

export const BookingsContext = React.createContext({
  allBookings: [],
  userBookings: [],
  courtId: ""
});
